
import * as actions from 'actions';
import emojisMaker from 'reducersMakers/emojisMaker';

export default emojisMaker({
  showType: actions.COMMENT_EMOJIS_SHOW,
  closeType: actions.COMMENT_EMOJIS_HIDE
});



/** WEBPACK FOOTER **
 ** ./src/members/state/comments/emojis/secondLevel/reducer.js
 **/